import styles from "./ourService.module.scss";
import { useRef, useState, useEffect } from "react";
import virtualImg from "../../assests/vitualdesignImg.png.png";
import webHostingImg from "../../assests/webHostingImg.png";
import cloudImg from "../../assests/cloudsupportImg.png";
import databaseImg from "../../assests/databaseImg.png";
import { useNavigate } from "react-router-dom";

export default function Ourservice() {

  const MyRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        setVisible(entry.isIntersecting);
        console.log(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );
    if (MyRef.current) {
      observer.observe(MyRef.current);
    }

    return () => {
      if (MyRef.current) observer.unobserve(MyRef.current);
    };
  }, [MyRef, visible]);


  const navigateDomain = () => {
    navigate('/domain')
  }

  const navigateMobile = () => {
    navigate('/mobile')
  }
  
  const navigateApplication = () => {
    navigate('/application')
  }

  const navigatePayment = () => {
    navigate('/payment')
  }

  

  // const boxObj = [
  //   {
  //     image:
  //       "https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/OUR_SERVICES/vectorVirtualMachine.png",
  //     title: "virtual machine",
  //     img: "https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/OUR_SERVICES/starVM.png",
  //     para: "We will provide a server in your home our technical team will come to your site and fix the server for your data base needed it will more help for your cost optimization and data base theft production.",
  //   },
  //   {
  //     image:
  //       "https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/OUR_SERVICES/vectorWebHosting.png",
  //     title: "web hosting",
  //     img: "https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/OUR_SERVICES/starVM.png",
  //     para: "We will provide a server in your home our technical team will come to your site and fix the server for your data base needed it",
  //   },
  //   {
  //     image:
  //       "https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/OUR_SERVICES/vectorCloudSupport.png",
  //     title: "cloud support",
  //     img: "https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/OUR_SERVICES/starCS.png",
  //     para: "We will provide a server in your home our technical team will come to your site and fix the server for your data base needed.",
  //   },
  //   {
  //     image:
  //       "https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/OUR_SERVICES/VectorDatabase.png",
  //     title: "database",
  //     img: "https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/OUR_SERVICES/starDB.png",
  //     para: "We will provide a server in your home our technical team will come to your site and fix the server for your data base needed it will more help for your cost optimization and data base theft production.",
  //   },
  // ];
  
  return (
    <div ref={MyRef} className={styles.container} id="ourServices">
      <div className={styles.wrapper}>
        <div className={visible ? styles.topTitle : styles.topTitleAction}>
          <div className={styles.pageTitle}>Our Services</div>
        </div>
        {/* <div className={styles.top}>
          <div className={styles.bottom}>
            {boxObj.map((item, index) => (
              <div key={index} className={styles.bottomContainer}>
                <div className={visible ? styles.boxOne : styles.boxOneAction}>
                  <div
                    className={styles.bottomBgImg}
                    style={{ backgroundImage: `url(${item.img})` }}
                  >
                    <div className={styles.boxTitle1}>
                      <div className={styles.topImg}>
                        <img
                          className={styles.boxImg}
                          src={item.image}
                          alt="img"
                        />
                      </div>
                      <div>
                        <h1>{item.title}</h1>
                        <p>{item.para}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div> */}
        <div className={styles.bottom} ref={MyRef}> 
          <div className={styles.bottomTop}>
            <div className={styles.bottomTopLeft}>
              <div className={styles.content}>
                {/* <div className={styles.cardImg}>
                  <img src={virtualImg} alt="" />
                </div> */}
                <div className={styles.leftContent}>
                  <div className={styles.title}>Domain Guidance</div>
                  <div className={styles.description}>
                    We will provide a server in your home our technical team
                    will come to your site and fix the server for your data base
                    needed it will more help for your cost optimization and data
                    base theft production.
                  </div>
                </div>
              </div>
              <div className={styles.button} onClick={navigateDomain}>Know More</div>
            </div>
            <div className={styles.bottomTopRight}>
              <div className={styles.content}>
                {/* <div className={styles.cardImg}>
                  <img src={webHostingImg} alt="" />
                </div> */}
                <div className={styles.rightContent}>
                  <div className={styles.title}>app Development</div>
                  <div className={styles.description}>
                    We will provide a server in your home our technical team
                    will come to your site and fix the server for your data base
                    needed it
                  </div>
                </div>
              </div>
              <div className={styles.button} onClick={navigateMobile}>Know More</div>
            </div>
          </div>
          <div className={styles.bottomTop}>
            <div className={styles.bottomTopRight}>
             <div className={styles.content}>
               {/* <div className={styles.cardImg}>
                <img src={cloudImg} alt="" />
              </div> */}
              <div className={styles.rightContent}>
                <div className={styles.title}>app deployment</div>
                <div className={styles.description}>
                  We will provide a server in your home our technical team will
                  come to your site and fix the server for your data base
                  needed.
                </div>
              </div>
             </div>
             <div className={styles.button} onClick={navigateApplication}>Know More</div>
            </div>
            <div className={styles.bottomTopLeft}>
              <div className={styles.content}>
                {/* <div className={styles.cardImg}>
                  <img src={databaseImg} alt="" />
                </div> */}
                <div className={styles.leftContent}>
                  <div className={styles.title}>Payment gateway</div>
                  <div className={styles.description}>
                    We will provide a server in your home our technical team
                    will come to your site and fix the server for your data base
                    needed it will more help for your cost optimization and data
                    base theft production.
                  </div>
                </div>
              </div>
              <div className={styles.button} onClick={navigatePayment}>Know More</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
